import { noneProfile } from "assets";
import React from "react";
import { Service } from "utils/services";

const Requester = ({ employeeInitRequest }: any) => {
  return (
    <>
      <div>
        <h4 className="text-xl font-semibold text-blue-600">Requester</h4>
        <table className="min-w-full border-collapse  overflow-hidden mt-2 rounded-md">
          <thead className="sticky top-0   ">
            <tr className="">
              <th className=" w-[100px] "></th>
              <th className="  w-[100px] "></th>
              <th className=" w-[100px] "></th>
              <th className="w-[100px]"></th>
            </tr>
          </thead>
          <tbody>
            <tr className={`group text-center  bg-gray-200 dark:bg-[#2c3a52] `}>
              <td className=" h-[100px] p-0 m-0">
                <img
                  className={`z-1 w-[100px] h-full rounded-tl-md rounded-bl-md  `}
                  src={!employeeInitRequest?.requester?.picture ? noneProfile : employeeInitRequest?.requester?.picture}
                  alt={employeeInitRequest?.request?.picture}
                />
              </td>
              <td className="py-2 px-4 text-md  text-left align-top  w-[200px]">
                <p className="text-[15px] font-bold "> {employeeInitRequest?.requester?.local_name}</p>
                <p className="text-md text-muted-foreground "> {employeeInitRequest?.requester?.english_name}</p>
                <p className="text-md text-muted-foreground ">{employeeInitRequest?.requester?.nationality}</p>
              </td>
              <td className="py-2 px-4  text-md  text-left align-top text-nowrap  w-[200px]">
                <p className="text-md "> {employeeInitRequest?.requester?.gender}</p>
                <p className="text-md text-muted-foreground"> {employeeInitRequest?.requester?.marital_status}</p>
                <p className="text-md flex items-center  gap-2  text-muted-foreground text-nowrap">
                  {(() => {
                    const date = new Date(employeeInitRequest?.requester?.date_of_birth);
                    const day = date.getDate();
                    const weekday = date.toLocaleDateString("en-GB", {
                      weekday: "short",
                    });
                    const month = date.toLocaleDateString("en-GB", {
                      month: "short",
                    });

                    const year = date.getFullYear();
                    return `${weekday}, ${day}-${month}-${year}`;
                  })()}
                </p>
              </td>
              <td className="py-2 px-4   text-md  text-left align-top  w-[200px]">
                <p className="text-md "> {employeeInitRequest?.requester?.phone_no}</p>
                <p className="text-md line-clamp-1 text-muted-foreground"> {employeeInitRequest?.requester?.email}</p>
                <p className="text-md text-muted-foreground">{employeeInitRequest?.requester?.address}</p>
              </td>

              <td className="py-2 px-4  text-md  text-left align-top  w-[200px]">
                <p className="text-md line-clamp-1 "> {employeeInitRequest?.requester?.department}</p>
                <p className="text-md text-muted-foreground "> {employeeInitRequest?.requester?.position}</p>
                <div className="flex items-center gap-1 text-muted-foreground">
                  <p className="text-md text-nowrap"> {Service.formatTime(employeeInitRequest?.requester?.timesheet?.starting_time)}</p>
                  {employeeInitRequest?.requester?.timesheet?.starting_time && employeeInitRequest?.requester?.timesheet?.ending_time && "-"}
                  <p className="text-md text-nowrap "> {Service.formatTime(employeeInitRequest?.requester?.timesheet?.ending_time)}</p>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </>
  );
};

export default Requester;
